import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import aliveRouter from './modules/aliveRouter'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  modules: {
    app,
    user,
    permission,
    aliveRouter
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js